import { Injectable } from '@angular/core';

type ViewState = Record<string, unknown>;

@Injectable({ providedIn: 'root' })
export class ViewStateService {
  private stateMap: Record<string, ViewState | false> = {};

  init(): void {}

  setState(key: string, state: ViewState): void {
    this.stateMap[key] = state;
  }

  getState(key: string): ViewState | false {
    if (Object.prototype.hasOwnProperty.call(this.stateMap, key)) {
      return this.stateMap[key];
    }
    return false;
  }

  resetState(key: string): void {
    this.stateMap[key] = false;
  }

  getStateProperty<T = unknown>(key: string, property: string, defaultValue: T): T {
    const state = this.stateMap[key];
    if (state && typeof state === 'object' && Object.prototype.hasOwnProperty.call(state, property)) {
      return (state as Record<string, unknown>)[property] as T;
    }
    return defaultValue;
  }

  setStateProperty(key: string, property: string, value: unknown): void {
    const state = this.stateMap[key];
    if (state && typeof state === 'object') {
      (state as Record<string, unknown>)[property] = value;
    }
  }
}
